/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};


/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
 
      if (isNaN(number) || number == null) {
        return 0;
      }
 
      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),
    $navArrows               : $('.thumb-nav-arrow'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  headerscroll();
  megaNav();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    
  });
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('.product-price'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Basket");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
  
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  var click
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    if($('body').hasClass('template-product')){
      if(this){
        var str = $('.product-description').html();
        var title = str.match(/[^\[\]]+(?=\])/g);
        $('.prod-video').addClass('active').html('<div class="video-wrapper"></div>');
        if( title ){
          $('.prod-video').prepend('<div class="video-title">'+title+'</div>');
        }
        $('.video-wrapper').html(this);
        $('.product-description').html(str.replace(/(\[.+\])/g, ''));
        $('.product-description iframe[src*="youtube.com/embed"], .product-description iframe[src*="player.vimeo"]').remove();
        $(".product-description p, .product-description span, .product-description div").each(function() { 
          var $el = $(this);
          if($.trim($el.html()) == "&nbsp;") {
            $el.remove();
          }
        });
      }
    } else {
      $(this).wrap('<div class="video-wrapper"></div>')
    }
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

function headerscroll(){
  $(window).on('scroll', function(){
    if( $(this).scrollTop() > 70 ){
      $('.site-header').addClass('sticky');
    } else {
      $('.site-header').removeClass('sticky');
    }
  });
}

function megaNav(){
  $(window).on('load resize', function(){
    console.log($(this).width());
    if( $(this).width() <= 1024 ){
      $('.site-nav li a').on('click', function(e){
        e.preventDefault();
      });
    }
  });

  $('.site-nav li').on('mouseenter click', function(e){

    var megaNavID = '.'+$(this).attr('data-meganav-id');
    $('.meganav').removeClass('meganav--show');
    
    if( $(megaNavID).hasClass('meganav--single') ){
      $(megaNavID).css('left', ($(this).offset().left - (( $(window).width() - $('.nav-wrapper').width() )/2))-30 );
    }

    $(megaNavID).addClass('meganav--show');
  });

  $('.main-content, .promo-bar, .site-header__logo').on('mouseenter click', function(){
    $('.meganav').removeClass('meganav--show');
  });
}

// Initialize Timber's JS on docready
$(timber.init);


/*
 * BOOTEA INTERNATIONAL
 *
 */
 
(function($){ 
  $(document).ready(function(){
  
    //store urls
    var eur_store = "//eu.bootea.com/?redirect_eur=true";
    var usd_store = "//us.bootea.com/?redirect_usd=true";
    var int_store = "//us.bootea.com/?redirect_usd=true";
    var gbp_store = "//bootea.com/?redirect_gbp=true";
     
    var testURL = window.location.href;
    
    
    //if it has redirected already set the cookie
    if(testURL == 'https://www.bootea.com/')
    {
       setTimeout( function(){
         $('.currency-picker').val("GBP");
       }, 100 );
    }
    
    if (testURL.search("/?redirect_gbp=true") >= 0){
      $.cookie('location', 'GBP-Site', { domain: '.bootea.com', path: '/', expires: 365 });
      $('.currency-picker option[value="GBP"]').prop('selected');
      $('.currency-picker').val("GBP").change();
    }
    
    function clearCookies(){
      $.removeCookie('location', { domain: '.bootea.com', path: '/', expires: 365 });
    }

    function redirectPath(redURL){
      var spliturl = redURL.split('?');
      var pathname = window.location.pathname;
      var finalUrl = "http://" + spliturl[0].replace('//','').replace('/','') + pathname + "?" + spliturl[1];
      window.location.href = finalUrl;
    }
 
    $('.eur-site-link').on('click', function(e){
      e.preventDefault();
      clearCookies();
      $.cookie('location', 'EUR-Site', { domain: '.bootea.com', path: '/', expires: 365 });
      setTimeout( function(){redirectPath(eur_store)}, 300 );
    });
 
    $('.usd-site-link').on('click', function(e){
      e.preventDefault();
      clearCookies();
      $.cookie('location', 'USD-Site', { domain: '.bootea.com', path: '/', expires: 365 });
      setTimeout( function(){redirectPath(usd_store)}, 300 );
    });

    $('.gbp-site-link').on('click', function(e){
      e.preventDefault();
      clearCookies();
      $.cookie('location', 'USD-Site', { domain: '.bootea.com', path: '/', expires: 365 });
      setTimeout( function(){redirectPath(gbp_store)}, 300 );
    });

    $('.int-site-link').on('click', function(e){
      e.preventDefault();
      clearCookies();
      setTimeout( function(){redirectPath(int_store)}, 300 );
    });
    
    $('.currency-picker').on('change', function(event){
      if (event.originalEvent != undefined) {
        clearCookies();
        var selectedLocation = $('.currency-picker option:selected').val();
        var selectedUrl = "";
        var selectedSite = "";
        if(selectedLocation == "GBP"){
          selectedSite = "GBP-Site";
          selectedUrl = gbp_store;
        } 
        else if(selectedLocation == "USD"){
          selectedSite = "USD-Site";
          selectedUrl = usd_store;
        }
        else if(selectedLocation == "EUR"){
          selectedSite = "EUR-Site";
          selectedUrl = eur_store;
        }

        var pathname = window.location.pathname;
        var spliturl = selectedUrl.split('?');
        
        var finalUrl = "http://" + spliturl[0].replace('//','').replace('/','') + pathname + "?" + spliturl[1];
        console.log(finalUrl);

        $.cookie('location', selectedSite, { domain: '.bootea.com', path: '/', expires: 365 });

        setTimeout( function(){window.location.href = finalUrl}, 1000 );
      }
    });
  
    if( $.cookie('location') == 'GBP-Site'){
      $('.currency-picker option[value="GBP"]').prop('selected');
      $('.currency-picker').val("GBP").change();
    }
    else if( $.cookie('location') == 'USD-Site'){
      $('.currency-picker option[value="USD"]').prop('selected');
      $('.currency-picker').val("USD").change();
    }
    else if( $.cookie('location') == 'EUR-Site'){
      $('.currency-picker option[value="EUR"]').prop('selected');
      $('.currency-picker').val("EUR").change();
    }
    
 
    if( $.cookie('location') == null || $.cookie('location') != 'GBP-Site' ){
      var onSuccess = function(location){
        var locationISo = JSON.stringify(location.country.iso_code);
        var contISo = JSON.stringify(location.continent.code);
        console.log(locationISo);
        if(contISo == '"NA"'){
          if (testURL.search("eur") >= 0){
            $('.modal-wrapper').fadeIn();
          }
          else if (testURL.search("usd") >= 0){
            $('.modal-wrapper').hide();
            $.cookie('location', 'USD-Site', { domain: '.bootea.com', path: '/', expires: 365 });
          }
          else {
            $('.modal-wrapper').fadeIn();
          }
        }
        else if(contISo == '"EU"' && locationISo != '"GB"'){
          if (testURL.search("eur") >= 0){
            $('.modal-wrapper').hide();
            $.cookie('location', 'EUR-Site', { domain: '.bootea.com', path: '/', expires: 365 });
          }
          else if (testURL.search("usd") >= 0){
            $('.modal-wrapper').fadeIn();
          }
          else {
            $('.modal-wrapper').fadeIn();
          }
        }
        else if(locationISo == "'GB'"){
          if (testURL.search("eur") >= 0){
            $('.modal-wrapper').fadeIn();
          }
          else if (testURL.search("usd") >= 0){
            $('.modal-wrapper').fadeIn();
          }
          else {
            $('.modal-wrapper').hide();
            $.cookie('location', 'USD-Site', { domain: '.bootea.com', path: '/', expires: 365 });
          }
        }
        else {
          //not in any of the main countries
          $('.modal-wrapper').fadeIn();
        }
      };
 
      var onError = function(error){
        console.log(
          "Error:\n\n"
          + JSON.stringify(error, undefined, 4)
          );
      };
 
      geoip2.country(onSuccess, onError);
    }

     
  });
})(jQuery);